import { render } from "./PieSummary.vue?vue&type=template&id=51c09c74&scoped=true"
import script from "./PieSummary.vue?vue&type=script&lang=js"
export * from "./PieSummary.vue?vue&type=script&lang=js"

import "./PieSummary.vue?vue&type=style&index=0&id=51c09c74&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c09c74"]])

export default __exports__